export function escapeRegExp(string) {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

/** Strip extension and trailing `_copyN` to get the root asset label. */
export function getAssetRootName(name) {
  if (!name) return 'asset';
  return String(name)
    .replace(/\.[^/.]+$/, '')
    .replace(/_copy\d+$/i, '')
    .trim() || 'asset';
}

/**
 * Unsaved / duplicated asset id: `temp-{timestamp}-{fileName}`
 * Uses the display file name (e.g. Cube_copy1), not only the root.
 * e.g. `temp-1785749619529-Cube_copy1`
 */
export function buildTempFileName(fileName) {
  const label =
    String(fileName || 'asset')
      .replace(/\.[^/.]+$/, '')
      .trim() || 'asset';
  return `temp-${Date.now()}-${label}`;
}

export function getNextCopyName(scene, baseName) {
  // Strip any existing _copy(\d+) suffix to find the true root name
  const rootName = getAssetRootName(baseName);
  let maxIndex = 0;

  const escapedRoot = escapeRegExp(rootName);

  scene.traverse((obj) => {
    const fileName = obj.userData?.file_name || obj.file_name || obj.name;
    if (!fileName) return;

    // Remove file extension to compare safely
    const nameOnly = fileName.replace(/\.[^/.]+$/, '');

    const match = nameOnly.match(new RegExp(`^${escapedRoot}_copy(\\d+)$`));
    if (match) {
      const num = parseInt(match[1], 10);
      if (num > maxIndex) maxIndex = num;
    }
  });

  return `${rootName}_copy${maxIndex + 1}`;
}
